// src/components/store/sections/faqs/FaqV36BentohelpRoyalViolet.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV36BentohelpRoyalViolet(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={36}
      archKey="bento_help"
      archLabel="Bento Help Matrix"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
